import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import type { FileModel } from "@/models/FileModel.ts";
import { Message } from "@/models/MessagingModel.ts";
import type { Theme } from "@/theme/CreateTheme.ts";
import { ReadOnlyFileManager } from "@/uiKit/molecules/FileManager.tsx";

export type MessageAttachmentsProps = {
  message: Message;
  className?: string;
};

export const MessageAttachments: React.FC<MessageAttachmentsProps> = ({ message, className }) => {
  const styles = useStyles(makeStyles);

  if (!message.attachments) {
    return null;
  }

  return message.attachments.map((attachment, index) => (
    <ReadOnlyFileManager
      key={attachment.name}
      id={`message-attachment-${message.id}-${index}`}
      label={attachment.name + attachment.name}
      file={attachment as FileModel}
      className={className}
      classes={{ root: styles.root, button: styles.button }}
    />
  ));
};

const makeStyles = (theme: Theme) => ({
  root: css({
    backgroundColor: theme.palette.common.white,
  }),
  button: css({
    backgroundColor: theme.palette.primary.contrastText,
  }),
});
